import React from 'react';
import { motion } from 'framer-motion';
import { AiOutlineBulb, AiOutlineBook } from 'react-icons/ai';
import { RenderMarkdownWithLatex } from '../../utils/utils';

const HintAndFormulas = ({ hintText, formulas }) => {
    const hasHint = hintText && hintText.trim() !== "";
    const hasFormulas = formulas && formulas.length > 0;

    if (!hasHint && !hasFormulas) return null;

    return (
        <div className="w-full space-y-4 mt-2 mb-4">
            
            {/* --- KARTA PODPOWIEDZI --- */}
            {hasHint && (
                <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="w-full bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden"
                >
                    {/* ZMIANA: Ciemny nagłówek (Navy) + Złoty akcent */}
                    <div className="bg-[#233855] px-4 py-1 flex items-center gap-2">
                        <AiOutlineBulb className="text-white  w-3 h-3" />
                        <span className="text-xs font-bold font-apotek uppercase tracking-widest text-white">
                            Podpowiedź
                        </span>
                    </div>

                    <div className="p-4 text-sm text-gray-700 leading-relaxed break-words">
                        <RenderMarkdownWithLatex text={hintText} />
                    </div>
                </motion.div>
            )}

            {/* --- KARTA WZORÓW --- */}
            {hasFormulas && (
                <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                    className="w-full bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden"
                >
                    {/* ZMIANA: Ciemny nagłówek (Navy) + Biały akcent */}
                    <div className="bg-[#233855] px-4 py-1 flex items-center gap-2">
                        <AiOutlineBook className="text-white w-3 h-3" />
                        <span className="text-xs font-bold font-apotek uppercase tracking-widest text-white">
                            Wzory z Karty Wzorów
                        </span>
                    </div>

                    <div className="divide-y divide-gray-100">
                        {formulas.map((formula, idx) => (
                            <div key={formula.matura_formula_match_id || idx} className="p-4">
                                {formula.name && (
                                    <div className="text-sm font-medium text-gray-600 mb-1 tracking-wide break-words">
                                        <RenderMarkdownWithLatex text={formula.name} />
                                    </div>
                                )}
                                <div className="text-sm text-gray-800 break-words">
                                    <RenderMarkdownWithLatex text={formula.text} />
                                </div>
                            </div>
                        ))}
                    </div>
                </motion.div>
            )}
        </div>
    );
};

export default HintAndFormulas;